import React,{Component} from 'react';
import './styles.scss';
import Signup from './../../components/Signup'
export default function Registration(props){
        return(
            <Signup/>
        )
}